import queryClient from '../../../../ReactQuery/client';
import useMutation from '../../../../ReactQuery/useMutation';
import { put } from '../../../../redux/api';
import type {
  FullTeamGroupResponse,
  TeamUserAction,
  UpdateTeamUsersResponse,
} from '../../../../../shared/types/routes/teamGroups';

import { getTeamGroupQueryKey } from './useTeamGroup';

//  Function for deleting a TeamGroup.
function removeUserFromTeamGroup(teamGroupId: number, userId: number) {
  return put<TeamUserAction, UpdateTeamUsersResponse>(`/api/teams/groups/${teamGroupId}/users`, {
    action: 'remove',
    users: [{ id: userId }],
  });
}

/**
 * Hook used to remove a user from a team group.
 */
export default function useRemoveUserFromTeamGroup(teamGroupId: number, userId: number) {
  return useMutation({
    mutationFn: () => removeUserFromTeamGroup(teamGroupId, userId),
    onSuccess: () => {
      //  Remove the team group from the cache
      queryClient.setQueryData(getTeamGroupQueryKey(teamGroupId), (oldData?: FullTeamGroupResponse) => {
        if (!oldData) {
          return oldData;
        }
        return {
          ...oldData,
          members: oldData.members?.filter((member) => member.userId !== userId),
        };
      });
    },
  });
}
